import styled from 'styled-components'
import { Mode } from '@ocean/types/dist/appearance'
import { StatusProgress, StatusProps } from './Status'

type RootProps = {
  mode: StatusProps['mode']
}

type MarkerProps = { status: StatusProgress }

export const Root = styled.div<RootProps>`
  display: inline-flex;
  align-items: center;

  ${({ theme }) => `
    background: ${theme.color.haze};
    padding: 6px 7px 6px 6px;
    border-radius: 12px;
  `}

  ${({ mode, theme }) =>
    mode === Mode.Dark &&
    `
    background: none;
    padding: 0;
    border-radius: 0;
    color: ${theme.color.white};
  `}
`

export const Marker = styled.div<MarkerProps>`
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-right: 6px;

  ${({ status, theme }) =>
    status === StatusProgress.InProgress &&
    `
    background: ${theme.color.fireBush};
  `}

  ${({ status, theme }) =>
    (status === StatusProgress.Completed || status === StatusProgress.Active) &&
    `
    background: ${theme.color.greenLight};
  `}

  ${({ status, theme }) =>
    [StatusProgress.ToDo, StatusProgress.Inactive, StatusProgress.Renew].includes(status) &&
    `
    background: ${theme.color.danger};
  `}
`

export const Label = styled.div``
